// Colored status pill. Looks up the Hebrew label + tone for a given kind.
import he from '../i18n/he';

const TONES = {
  invoice: { draft: 'gray', issued: 'blue', partially_paid: 'amber', paid: 'green', cancelled: 'gray' },
  job: { open: 'blue', in_progress: 'amber', completed: 'green', cancelled: 'gray' },
  retainer: { active: 'blue', completed: 'green', cancelled: 'gray' },
};

const LABELS = { invoice: he.invoiceStatus, job: he.jobStatus, retainer: he.retainerStatus };

// The two job statuses that mean "off the active list" — the same pair the server calls
// CLOSED_JOB_STATUSES. Defined here, beside the vocabulary it belongs to, so the three
// screens that split their job list on it cannot drift apart on what "finished" means.
// A VIEW question only: no figure anywhere is computed from a job's status.
export const isJobDone = (status) => status === 'completed' || status === 'cancelled';

export default function StatusBadge({ kind, value }) {
  const tone = (TONES[kind] && TONES[kind][value]) || 'gray';
  const label = (LABELS[kind] && LABELS[kind][value]) || value;
  return <span className={`badge ${tone}`}>{label}</span>;
}
